import React from 'react';

export const LabelRequired: React.FC = () => (
  <span className="color-primary ml-1-px">*</span>
);